export const ProductLineText = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.3996 9.0002L20.3996 6.6002C20.3996 5.27471 19.3251 4.2002 17.9996 4.2002H5.99961C4.67413 4.2002 3.59961 5.27471 3.59961 6.60019V17.4002C3.59961 18.7257 4.67413 19.8002 5.99961 19.8002L11.9996 19.8002"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M20.0528 12.8562L16.0094 16.8996C15.747 17.162 15.5996 17.5178 15.5996 17.8889V18.9257C15.5996 19.4086 15.9911 19.8001 16.474 19.8001L17.5109 19.8C17.8819 19.8 18.2377 19.6526 18.5001 19.3903L22.5435 15.3468C22.8562 15.0342 22.8853 14.5388 22.6158 14.1922L22.5657 14.1339L21.2893 12.8562C20.9478 12.5147 20.3943 12.5147 20.0528 12.8562Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.3996 11.9999L10.7996 14.0784L10.7996 9.92144L14.3996 11.9999Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);
